module.exports = __webpack_public_path__ + "static/media/Peter-Laurentius.a7b263a7.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/Peter-Laurentius.png
// module id = 185
// module chunks = 0